import(/* webpackMode: "eager" */ "/home/ubuntu/download/697f079c921dc90014c31c26/tradinghub/src/app/inquiry/page.tsx");
